/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { MyInput, MyNormalInput } from "../dynamicComponent/myInputs";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import ReadVAxios from "../axiosComponent/readV";
import moment from "moment";
import DeleteAxios from "../axiosComponent/delete";

const ModalVendorReplayAllot = ({ values, isSubmitting, handleSubmit, setFieldValue, t, orderDetails, vendorDetail, currentOrder }) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [dissablebtn, setdissablebtn] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const [VendorsBid, setVendorsBid] = useState("");
  const [VendorInfo, setVendorInfo] = useState({});
  const [deliveryNo, setgetdeliveryNo] = useState([]);
  useEffect(() => {
    getAllVendors();
    console.log('status', orderDetails);
    console.log('vendor', vendorDetail);
    console.log('current', currentOrder);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${currentOrder.vendor_order_id}`,
    }).then((res) => {
      let testlr = [];
      // setgetCurrentOrderDetails(res.data.order);
      res.data.order.deliveries.map((del, index) => {
        console.log('in map', del.transporter_lr_no);
        testlr.push(del.delivery_no)
        setgetdeliveryNo(testlr)
      })
      setFieldValue('lrnos', testlr)
      console.log('dl no', testlr);
    });
    // console.log('order', order);
    if (vendorDetail && vendorDetail.vendor_id) {
      ReadVAxios({ url: `vendorDetails/${vendorDetail.vendor_id}` })
            .then((res) => {
               console.log(res.data.resultSet);
               setVendorInfo(res.data.resultSet);
               setFieldValue("vendorcode", res.data.resultSet.transporterCode)
            })
            .catch((err) => {
                console.log(err);
                // this.setState({ loadingData: false, rowData: [] });
            });
    }
    if (vendorDetail && vendorDetail.bids.length > 0) {
      setVendorsBid(vendorDetail.bids[0].bid_amount)
      setFieldValue("freight_rate", Number(vendorDetail.bids[0].bid_amount))
    }
    if (orderDetails) {
      console.log('in if status', orderDetails.vendors);
      for (let index = 0; index < orderDetails.vendors.length; index++) {
        const element = orderDetails.vendors[index];
        if (orderDetails.vendors[index].vendor_interest_status.allotment_code == "WAITINGVEH") {
          setdissablebtn(true);
        }
      }
    }
  }, []);
  let handleOpen = () => setmodalOpen(true);
  let handleClose = () => {
    setmodalOpen(false);
  };
  let handleSubmited = () => {
    setmodalOpen(false);
     handleSubmit();
  };

  const getAllVendors = () => {
    ReadAxios({ url: `transporterMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendors([])
          : setVendorsState(res.data.resultSet);
      })
      .catch((err) => setVendors([]));
  };
  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.transporterName,
        key: item.transporterCode,
        value: item.transporterMasterId,
      };
    });
    setVendors(result);
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="tiny"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            disabled={dissablebtn}
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("title_button") || "Allot"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">{t("title") || "Allot Shipment"}</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description style={{ height: "10em" }}>
            <div className="ui form">
              {/* <Dropdown
                name="vendor"
                clearable
                search
                style={{ width: "100%" }}
                selection
                placeholder={t("vendor.placeholder") || "Select Vendor"}
                onChange={(name, data) => setFieldValue("vendor", data.value)}
                options={Vendors}
                defaultValue={values.vendor}
              /> */}
              <FormUi.Field
                width={12}
                // error={
                //   touched.final_rate &&
                //     errors.final_rate
                //     ? true
                //     : false
                // }
              >
                <label className="labelName mt-2">
                  {t("final_rate.title") || "Final Rate"}
                </label>
                <Fieldmik
                  component={MyNormalInput}
                  type="number"
                  name="freight_rate"
                />
                {/* {touched.final_rate &&
                  errors.final_rate ? (
                    <div className="w3-text-red w3-tiny">
                      {props.t(
                        `final_rate.error_msg.${errors.final_rate}`
                      ) || errors.final_rate}
                    </div>
                  ) : null} */}
              </FormUi.Field>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          <Button
            type="submit"
            onClick={handleSubmited}
            // disabled={isSubmitting || values.vendor ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("action_button.submit") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
const FormikReplayVendorsModalAllot = withFormik({
  mapPropsToValues(props) {
    if (props.vendorDetail.bids.length > 0) {
      var freight_rate = Number(props.vendorDetail.bids[0].bid_amount);
    }
    return {
      freight_rate: freight_rate || 0,
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    let no = Number(localStorage.getItem("customerNumber"));
    //  if (no == 1122 || no == 1123 ) {
      CreateAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.order}/allocate/vendor/${props.vendorId}`,
         payload: { ...values}
      })
        .then((res) => {
          setSubmitting(false);
          console.log(res);
          props.successAlertDispatcher({
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.message,
          });
          // props.reFetchOrder();
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          props.successAlertDispatcher({
            type: "error",
            messageHeader: "Error",
            messageBody: err.message,
          });
        });
    //  } else {
    //   let billData = {"hire_memo_id": "", "hire_memo_no": "", "purchase_order_no": "", "purchase_order_id": ""}
    //   console.log('props', props);
    //   let hirememodata = {
    //     "hireMemoDate":moment(new Date()).format("YYYY-MM-DD"),
    //     "lrNo": values.lrnos,
    //     "vendorCode":values.vendorcode,
    //     "vehicleNo":"",
    //     "vehicleType":"",
    //     "fromCity":"",
    //     "toCity":"",
    //     "branchCode":"",
    //     "hireCharge":+values.freight_rate,
    //     "tdsCharge":0,
    //     "advanceGiven":0,
    //     "remarks":"",
    //     "accountName":"",
    //     "accountNo":0,
    //     "ifscCode":"",
    //     }
    //     CreateAxios({
    //       completeURL: `${process.env.REACT_APP_BASE_COMMON}/hm/create`,
    //       payload: { ...hirememodata },
    //     })
    //     .then((res) => {
    //       console.log(res);
    //       billData.hire_memo_id = res.data.data.id;
    //       billData.hire_memo_no = res.data.data.hireMemoNo;
    //       if (res.data.status == true) {
    //         let po = {
    //           "poReferenceNo": res.data.data.hireMemoNo,
    //           "vendorCode": values.vendorcode,
    //           "branchCode": "",
    //           "vendorBranchCode": "",
    //           "vehicleNo": "",
    //           "poQuantity": 1,
    //           "poAmount": values.freight_rate,
    //           "sgstAmount": "",
    //           "cgstAmount": "",
    //           "igstAmount": "0.00",
    //           "adjustment": "0.00",
    //           "totalOrderAmt": values.freight_rate,
    //           "remarks": "",
    //           "gstTaxType": 0,
    //           "poDate": moment(new Date()).format("YYYY-MM-DD"),
    //           "tdsAmount": "0.00",
    //           "taxableAmount": "0.00",
    //           "totalDiscount": "0.00",
    //           "psDetails": [
    //             {
    //               "psCode": "PS00006",
    //               "psName": "",
    //               "psQty": "",
    //               "psPrice": values.freight_rate,
    //               "psAmount": values.freight_rate,
    //               "totalAmount": values.freight_rate,
    //               "igstPercent": 0,
    //               "igstAmount": "",
    //               "cgstPercent": 0,
    //               "cgstAmount": "",
    //               "sgstPercent": 0,
    //               "sgstAmount": "",
    //               "tdsCode": "",
    //               "tdsAmount": "",
    //               "startDate": "",
    //               "endDate": "",
    //               "discount": 0,
    //               "finalDiscount": 0,
    //               "discountType": 0,
    //               "taxableAmount": 0
    //             }
    //           ]
    //         }
    //         CreateAxios({
    //           completeURL: `${process.env.REACT_APP_BASE_COMMON}/purchase/purchaseorder/create`,
    //           payload: { ...po },
    //         })
    //         .then((res) => {
    //           billData.purchase_order_no = res.data.data[0].poReferenceNo;
    //           billData.purchase_order_id = res.data.data[0].poId;
    //           if (res.data.status == 1) {
    //             console.log('bill',billData );
    //           CreateAxios({
    //             completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.order}/allocate/vendor/${props.vendorId}`,
    //             payload: { ...values, ...billData}
    //           })
    //             .then((res) => {
    //               setSubmitting(false);
    //               console.log(res);
    //               props.successAlertDispatcher({
    //                 type: "success",
    //                 messageHeader: "Success",
    //                 messageBody: res.data.message,
    //               });
    //               // props.reFetchOrder();
    //               window.location.reload();
    //             })
    //             .catch((err) => {
    //               console.log(err);
    //               props.successAlertDispatcher({
    //                 type: "error",
    //                 messageHeader: "Error",
    //                 messageBody: err.message,
    //               });
    //             });   
    //           }
    //         })
    //         .catch((err) => {
    //           console.log(err);
    //         });
    //       }
          
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    //  }
    
    
  },
})(ModalVendorReplayAllot);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikReplayVendorsModalAllot)
);
